<template>
  <AnkleBootsCollectionPage />
</template>

<script setup lang="ts">
import AnkleBootsCollectionPage from './index.vue'
</script>
